import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdvertisingPolicy from "./pages/AdvertisingPolicy";

import TicTacToe from "./games/TicTacToe/TicTacToe";
import Snake from "./games/Snake/Snake";
import MemoryCard from "./games/MemoryCard/MemoryCard";
import Sudoku from "./games/Sudoku/Sudoku";
import FlappyBird from "./games/FlappyBird/FlappyBird";
import CodingPuzzle from "./games/CodingPuzzle/CodingPuzzle";
import MinesWeeper from "./games/Minesweeper/Minesweeper";
import TypingChallenge from "./games/TypingChallenge/TypingChallenge";
import AdvancedMathQuiz from "./games/AdvancedMathQuiz/AdvancedMathQuiz";
import NumberSequence from "./games/NumberSequenceGame/NumberSequenceGame";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>

        {/* Main pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contactUs" element={<ContactUs />} />

        {/* Legal & earning requirement pages */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/advertising" element={<AdvertisingPolicy />} />

        {/* Games */}
        <Route path="/tictactoe" element={<TicTacToe />} />
        <Route path="/snake" element={<Snake />} />
        <Route path="/memory" element={<MemoryCard />} />
        <Route path="/sudoku" element={<Sudoku />} />
        <Route path="/flappybird" element={<FlappyBird />} />
        <Route path="/codingpuzzle" element={<CodingPuzzle />} />
        <Route path="/minesweeper" element={<MinesWeeper />} />
        <Route path="/typingchallenge" element={<TypingChallenge />} />
        <Route path="/advancedmathquiz" element={<AdvancedMathQuiz />} />
        <Route path="/numbersequencegame" element={<NumberSequence />} />

      </Routes>
    </Router>
  );
}

export default App;
